<template>
	<div class="form-bookmark">
		<b-form @submit.prevent="submit">
			<b-form-group label="Bookmark link" label-for="url">
				<b-form-input
					id="name"
					v-model="form.url"
					type="url"
					required
					placeholder="https://underlineme.com"
				></b-form-input>
			</b-form-group>
			<div class="form-bookmark__flex">
				<FolderSelect
					@change="onFolderChange"
					v-if="folders.length > 0"
				></FolderSelect>
				<BucketSelect
					@change="onBucketChange"
					v-if="buckets.length > 0"
				></BucketSelect>
			</div>
			<b-button
				type="submit"
				variant="primary"
				:disabled="lock"
				:class="[{ disabled: lock === true }]"
				>Bookmark<b-spinner :class="['ml-1']" small v-if="lock"></b-spinner
			></b-button>
			<div class="form-error" v-if="errorMessage">
				{{ errorMessage }}
			</div>
		</b-form>
	</div>
</template>

<script>
import { CheckIcon, XIcon } from 'vue-feather-icons';
import FolderSelect from '@/components/ui/folder-select';
import BucketSelect from '@/components/ui/bucket-select';
import { required, minLength, between } from 'vuelidate/lib/validators';
import emailValidator from '@/lib/email-validator.js';
export default {
	components: {
		BucketSelect,
		FolderSelect,
		CheckIcon,
		XIcon,
	},
	data: function () {
		return {
			lock: false,
			errorMessage: '',
			form: {
				bucket: null,
				folder: null,
				url: '',
			},
		};
	},
	validations: {
		form: {
			url: {
				required,
			},
		},
	},
	computed: {
		folders: function () {
			return this.$store.getters['folder/folder'];
		},
		buckets: function () {
			return this.$store.getters['bucket/bucket'];
		},
	},
	methods: {
		onFolderChange: function (f) {
			if (f) {
				this.form.folder = f._id;
			} else {
				this.form.folder = null;
			}
		},
		onBucketChange: function (f) {
			if (f) {
				this.form.bucket = f._id;
			} else {
				this.form.bucket = null;
			}
		},
		reset: function () {
			this.form = {
				bucket: null,
				folder: null,
				url: '',
			};
		},
		signup: function (data) {
			this.$store.dispatch('user/setToken', data);
			this.$store.dispatch('user/afterLogin', null, { root: true });
			this.$store.commit('user/SET_AFTER_SIGNUP', null, { root: true });
		},
		error: function () {
			this.errorMessage = `Please use a valid url for a bookmark.`;
		},
		submit: function () {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.lock = true;
				this.$store
					.dispatch('note/bookmark', this.form)
					.then((data) => {
						setTimeout(() => {
							this.lock = false;
							if (data) {
								this.$emit('onSuccess');
								this.$store.dispatch('message/onBookmark');
								this.reset();
							} else {
								this.error();
							}
						}, 1000);
					})
					.catch((err) => {
						this.lock = false;
						this.error();
					});
			}
		},
	},
};
</script>

<style lang="scss">
.form-bookmark {
	&__flex {
		margin-bottom: var(--margin-lg);
		display: flex;

		div {
			margin-right: var(--margin);
		}
	}
}
</style>
